import {Component, inject} from '@angular/core';
import {MatButton} from "@angular/material/button";
import {MatInput, MatLabel} from "@angular/material/input";
import {MatTab, MatTabChangeEvent, MatTabGroup} from "@angular/material/tabs";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect, MatSelectChange} from "@angular/material/select";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {ProductCardsDefectValuesService} from "../../../services/product-cards-defect-values.service";
import {MatFormField} from "@angular/material/form-field";
import {productCardDefectValueModalName} from "./config/product-card-defect-value-config";
import {ProductCardDefectValueDialogData} from "./types/product-card-defect-modal.types";
import {BaseModalComponent} from "../../../../../../core/components/modals/base-modal/base-modal.component";
import {ProductCardDefectValue} from "../../../types/product-card-defect.types";
import {RecordsDataRequestQueryParams} from "../../../../../../core/types/records-table.types";
import {
  defaultRecordsDataRequestQueryParams
} from "../../../../../../core/models/default-records-data-request-query-params";
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'app-product-card-defect-value-modal',
  imports: [
    BaseModalComponent,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    MatTab,
    MatTabGroup,
    FormsModule
  ],
  templateUrl: './product-card-defect-value-modal.component.html',
  styleUrl: './product-card-defect-value-modal.component.scss'
})
export class ProductCardDefectValueModalComponent extends BaseModalComponent {
  public productCardDefectValueDialogData = inject<ProductCardDefectValueDialogData>(MAT_DIALOG_DATA);
  private productCardsDefectValuesService: ProductCardsDefectValuesService = inject(ProductCardsDefectValuesService);

  public name: string = '';
  public selectedDefectValue: number = 0;
  public selectedDefect: number = 0;
  public defectValues: Array<ProductCardDefectValue> = [];
  public hasDefectValues: boolean = false;
  private selectedTab: number = 0;

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(productCardDefectValueModalName);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(productCardDefectValueModalName);
  }

  public handleTabChange(event: MatTabChangeEvent): void {
    this.selectedTab = event.index;
    this.name = '';
    this.selectedDefectValue = 0;
  }

  public async handleBtn(): Promise<void> {
    const actions = [
      () => this.productCardsDefectValuesService.createProductCardsDefectValue({
        productDefectId: this.selectedDefect,
        value: this.name,
        productCardId: this.productCardDefectValueDialogData.productCardId
      }),
      () => this.productCardsDefectValuesService.updateProductCardsDefectValue({
        id: this.selectedDefectValue,
        value: this.name
      }),
      () => this.productCardsDefectValuesService.deleteProductCardsDefectValue(this.selectedDefectValue)
    ];

    const action = actions[this.selectedTab];
    await action().finally(() => this.closeDialog('cancel'));
  }

  public async getDefectValues(event: MatSelectChange): Promise<void> {
    if (event.value === this.selectedDefect) { return; }

    this.defectValues = await this.getProductCardDefectValues(event.value);
  }

  public getBtnText(): string {
    const labels = [ 'Создать', 'Обновить', 'Удалить' ];
    return labels[this.selectedTab] || 'Удалить';
  }

  public isDisabledBtn(): boolean {
    return this.selectedTab === 2 ? !this.selectedDefectValue : !this.name;
  }

  private async getProductCardDefectValues(defect: number): Promise<Array<ProductCardDefectValue>> {
    const queryParams: RecordsDataRequestQueryParams = {
      ...defaultRecordsDataRequestQueryParams,
      size: undefined,
      productCardDefectId: defect
    };

    const defectValues = await this.productCardsDefectValuesService.getProductCardsDefectValues(queryParams).catch(() => []);
    this.selectedDefect = defect;
    this.hasDefectValues = !!defectValues.length;
    return defectValues;
  }
}
